"use client";

import { useState, useEffect } from "react";
import { Breakpoints, ScreenSize } from "@/constants";
import { useDebounce } from "@/hooks/useDebounce";

const getBreakpoint = (width: number): ScreenSize => {
  if (width < Breakpoints.sm) return ScreenSize.xs;
  if (width < Breakpoints.md) return ScreenSize.sm;
  if (width < Breakpoints.lg) return ScreenSize.md;
  if (width < Breakpoints.xl) return ScreenSize.lg;
  if (width < Breakpoints["2xl"]) return ScreenSize.xl;
  return ScreenSize["2xl"];
};

export const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );
  const width = useDebounce(screenWidth, 150);
  const [breakpoint, setBreakpoint] = useState<ScreenSize>(
    getBreakpoint(screenWidth),
  );

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setScreenWidth(newWidth);
      setBreakpoint(getBreakpoint(newWidth));
    };

    window.addEventListener("resize", handleResize);

    // Set initial values
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { width, breakpoint };
};
